import * as i18next from 'i18next';
var i18nextInstance;
var DEFAULT_LANGUAGE = 'en';
function isI18nInitialized() {
    return i18nextInstance && !!i18nextInstance.options.lng;
}
function getTranslation(locale) {
    try {
        return require("../assets/locale/messages_" + locale + ".json");
    }
    catch (e) {
        return require("../assets/locale/messages_" + DEFAULT_LANGUAGE + ".json");
    }
}
export function translate(key) {
    if (!isI18nInitialized()) {
        i18n({ locale: DEFAULT_LANGUAGE });
    }
    return i18nextInstance.t(key);
}
export function i18n(_a) {
    var _b;
    var locale = _a.locale, fallbackLang = _a.fallbackLang;
    i18nextInstance = i18next.createInstance();
    i18nextInstance.init({
        resources: (_b = {},
            _b["" + locale] = {
                translation: getTranslation(locale),
            },
            _b),
        lng: locale,
        fallbackLng: [fallbackLang, DEFAULT_LANGUAGE],
        debug: false,
        keySeparator: '$',
        interpolation: {
            escapeValue: false,
        },
        react: {
            wait: false,
            bindI18n: 'loaded',
        },
    });
}
export var i18nInboxCommonService = {
    i18n: i18n,
    translate: translate,
};
//# sourceMappingURL=i18n.js.map